import httpService from '@/modules/common/services/httpService';

// The business portal reads its own services through the business-scoped settings API.
// The client-facing platform API deliberately caps what it returns - a single service on a
// single_service_booking plan, max_free_services otherwise - which hid services from the
// businesses that own them (VCITA2-15147). settings/categories nests each category's
// services, so one request replaces the previous per-category, paginated fan-out.
const categoriesRoute = 'v2/settings/categories';

const getServicesCategories = () => httpService.get(categoriesRoute).then((res) => res.data);

const getAllServices = async () => {
  const categories = await getServicesCategories();
  return (categories || []).reduce((services, category) => services.concat(category.services || []), []);
};

export default {
  getServicesCategories,
  getAllServices,
};
